import { useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import {
  addList,
  editList,
  removeList,
} from "../../controllers/ListOperations";
import { DocumentoNaoCompensado } from "../../model/PrestacaoDeContas/ConciliacaoBancaria";

type Props = {
  refRelatorio?: DocumentoNaoCompensado;
  closeModal: Function;
  list: DocumentoNaoCompensado[];
  setList: React.Dispatch<React.SetStateAction<DocumentoNaoCompensado[]>>;
  index?: number;
};

const ModalConciliacaoBancaria = ({
  refRelatorio,
  closeModal,
  list,
  setList,
  index,
}: Props) => {
  const [nomeDocumento, setNomeDocumento] = useState(refRelatorio?.nome || "");
  const [numero, setNumero] = useState(refRelatorio?.numero || "");
  const [data, setData] = useState(refRelatorio?.data || new Date(Date.now()));
  const [favorecido, setFavorecido] = useState(refRelatorio?.favorecido || "");
  const [valor, setValor] = useState(refRelatorio?.valor || 0);

  return (
    <form className={styles.formModal}>
      <h2>Documento Emitido e Não Compensado</h2>
      <div className={styles.camposDados}>
        <Campo
          title="Nome do Documento"
          type="text"
          maxLength={64}
          required={true}
          setter={setNomeDocumento}
          value={nomeDocumento}
        />
        <div className={styles.gridCampos}>
          <Campo
            title="Numero do Documento"
            type="text"
            maxLength={64}
            required={true}
            setter={setNumero}
            value={numero}
          />
          <Campo
            title="Data do Documento"
            type="date"
            maxLength={64}
            required={true}
            setter={setData}
            value={data}
          />
        </div>
        <Campo
          title="Nome do Favorecido"
          type="text"
          maxLength={64}
          required={true}
          setter={setFavorecido}
          value={favorecido}
        />
        <Campo
          title="Valor"
          type="number"
          maxLength={64}
          required={true}
          setter={setValor}
          value={valor}
        />
      </div>

      {!refRelatorio && (
        <input
          type="submit"
          value="+ Adicionar Relatório"
          className={styles.addBtn}
          onClick={(e) => {
            e.preventDefault();
            const item: DocumentoNaoCompensado = {
              nome: nomeDocumento,
              numero: numero,
              data: data,
              favorecido: favorecido,
              valor: valor,
            };

            addList({
              item,
              list,
              setList,
            });
            closeModal();
          }}
        />
      )}
      {refRelatorio !== undefined && index !== undefined && (
        <div className={styles.gridCampos}>
          <input
            type="submit"
            value="Editar Relatório"
            className={styles.addBtn}
            onClick={(e) => {
              e.preventDefault();
              const item: DocumentoNaoCompensado = {
                nome: nomeDocumento,
                numero: numero,
                data: data,
                favorecido: favorecido,
                valor: valor,
              };
              editList({
                item,
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
          <input
            type="submit"
            value="Remover Meta"
            className={styles.removeBtn}
            onClick={(e) => {
              e.preventDefault();
              removeList({
                index,
                list,
                setList,
              });
              closeModal();
            }}
          />
        </div>
      )}
    </form>
  );
};

export default ModalConciliacaoBancaria;
